import { render, staticRenderFns } from "./Index-Dashboard.vue?vue&type=template&id=368f7b3e&scoped=true&"
import script from "./Index-Dashboard.vue?vue&type=script&lang=js&"
export * from "./Index-Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Index-Dashboard.vue?vue&type=style&index=0&id=368f7b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f7b3e",
  null
  
)

export default component.exports